import { reactive as R, defineComponent as S, openBlock as i, createElementBlock as r, unref as d, Fragment as h, createTextVNode as C, renderList as O, normalizeClass as D, createElementVNode as n, toDisplayString as l, createCommentVNode as y, ref as I, shallowRef as j, withDirectives as E, vShow as H, createBlock as P, resolveDynamicComponent as U } from "vue";
const v = R([]);
let T = !1;
function A() {
  return {
    initConsole: () => {
      if (T)
        return;
      const a = console.log.bind(console), _ = console.warn.bind(console), s = console.error.bind(console);
      console.log = function(...e) {
        a.apply(console, e), v.push({
          type: "logs",
          log: Array.from(e),
          date: /* @__PURE__ */ new Date()
        });
      }, console.warn = function(...e) {
        _.apply(console, e), v.push({
          type: "warn",
          log: Array.from(e),
          date: /* @__PURE__ */ new Date()
        });
      }, console.error = function(...e) {
        s.apply(console, e), v.push({
          type: "error",
          log: Array.from(e),
          date: /* @__PURE__ */ new Date()
        });
      }, T = !0;
    },
    logs: v
  };
}
const w = R([]);
function V() {
  return {
    requests: w,
    addRequest: (s) => {
      w.push({
        ...s,
        startDate: /* @__PURE__ */ new Date()
      });
    },
    addRequestResponseById: (s, e, k) => {
      const u = w.find((f) => f.id === s);
      return u ? (u.endDate = /* @__PURE__ */ new Date(), u.statusCode = e, u.response = k, !0) : !1;
    },
    clearRequests: () => w.splice(0, w.length)
  };
}
const B = (p) => {
  let a = p.getHours().toString(), _ = p.getMinutes().toString(), s = p.getSeconds().toString();
  return a.length === 1 && (a = "0" + a), _.length === 1 && (_ = "0" + _), s.length === 1 && (s = "0" + s), [a, _, s].join(":");
}, q = { class: "console-option" }, L = {
  key: 1,
  class: "console-option__logs"
}, z = { class: "console-option__time" }, F = /* @__PURE__ */ S({
  __name: "ConsoleOption",
  setup(p) {
    const { logs: a } = A();
    return (_, s) => (i(), r("div", q, [
      d(a).length ? (i(), r("ul", L, [
        (i(!0), r(h, null, O(d(a), (e) => (i(), r("li", {
          key: e.date.toString(),
          class: D(["console-option__log", `console-option__log--${e.type}`])
        }, [
          n("span", z, l(d(B)(e.date)), 1),
          C(" > " + l(e.log.join("")), 1)
        ], 2))), 128))
      ])) : (i(), r(h, { key: 0 }, [
        C("No logs")
      ], 64))
    ]));
  }
});
const J = { class: "network-option" }, W = { class: "network-option__requests" }, Y = { class: "network-option__request-block" }, G = { class: "network-option__important" }, K = { class: "network-option__details" }, Q = /* @__PURE__ */ n("summary", { class: "network-option__important" }, "Headers", -1), X = { class: "network-option__code" }, Z = {
  key: 0,
  class: "network-option__request-block network-option__details"
}, tt = /* @__PURE__ */ n("summary", { class: "network-option__important" }, "Body", -1), et = { class: "network-option__code" }, ot = { class: "network-option__request-block" }, nt = ["onClick"], st = { class: "network-option__request-block" }, it = {
  key: 0,
  class: "network-option__important network-option__pending"
}, rt = { key: 1 }, ct = ["onClick"], at = { key: 0 }, _t = { class: "network-option__code" }, lt = { class: "network-option__clear" }, pt = /* @__PURE__ */ S({
  __name: "NetworkOption",
  setup(p) {
    const a = {
      1: "info",
      2: "success",
      3: "redirect",
      4: "err",
      5: "err"
    }, { requests: _, clearRequests: s } = V(), e = R([]), k = (o) => e.includes(o), u = (o) => {
      if (!k(o))
        return f(o);
      $(o);
    }, f = (o) => {
      e.push(o);
    }, $ = (o) => {
      const c = e.findIndex((t) => t === o);
      c >= 0 && e.splice(c, 1);
    }, b = (o) => {
      navigator.clipboard.writeText(JSON.stringify(o));
    }, x = (o) => {
      if (o.endDate) {
        const c = o.startDate.valueOf() - o.endDate.valueOf();
        return String(Math.abs(c));
      }
      return "...";
    }, m = (o) => {
      let c = o.url;
      if (o.params && typeof o.params == "object")
        for (const t of Object.keys(o.params)) {
          const g = o.params[t];
          if (g) {
            c.includes("?") || (c += "?");
            const M = c[c.length - 1] === "?" ? "" : "&";
            c += `${M}${t}=${g}`;
          }
        }
      return c;
    }, N = (o) => {
      const c = String(o), t = "network-option__status--", g = a[c[0]] || "err";
      return t + g;
    };
    return (o, c) => (i(), r("div", J, [
      d(_).length ? (i(), r(h, { key: 1 }, [
        n("ul", W, [
          (i(!0), r(h, null, O(d(_), (t) => (i(), r("li", {
            key: t.startDate.toString(),
            class: "network-option__request"
          }, [
            n("div", Y, [
              t.statusCode ? (i(), r("span", {
                key: 0,
                class: D(["network-option__status network-option__important", N(t.statusCode)])
              }, l(t.statusCode), 3)) : y("", !0),
              n("span", G, l(d(B)(t.startDate)), 1),
              C(" > " + l(t.method.toUpperCase()) + " " + l(m(t)), 1)
            ]),
            n("details", K, [
              Q,
              n("pre", X, l(t.headers), 1)
            ]),
            t.body ? (i(), r("details", Z, [
              tt,
              n("pre", et, l(t.body), 1)
            ])) : y("", !0),
            n("div", ot, [
              n("button", {
                class: "network-option__btn network-option__btn-clipboard",
                onClick: (g) => b(t)
              }, " Copy ", 8, nt)
            ]),
            n("div", st, [
              t.response ? (i(), r("div", rt, [
                n("button", {
                  class: D(["network-option__btn network-option__btn-details network-option__important", {
                    "network-option__btn-details--active": k(t.id)
                  }]),
                  onClick: (g) => u(t.id)
                }, " Details (" + l(x(t)) + " ms) ", 11, ct),
                k(t.id) ? (i(), r("div", at, [
                  n("pre", _t, l(t.response), 1)
                ])) : y("", !0)
              ])) : (i(), r("div", it, " Pending details... "))
            ])
          ]))), 128))
        ]),
        n("div", lt, [
          n("button", {
            class: "network-option__btn network-option__btn-clear",
            onClick: c[0] || (c[0] = //@ts-ignore
            (...t) => d(s) && d(s)(...t))
          }, " Clear requests ")
        ])
      ], 64)) : (i(), r(h, { key: 0 }, [
        C("No requests")
      ], 64))
    ]));
  }
});
const ut = { class: "miniapp-debugbar-container" }, dt = {
  key: 0,
  class: "miniapp-debugbar"
}, kt = { class: "miniapp-debugbar__options" }, bt = ["onClick"], mt = { class: "miniapp-debugbar__body" }, ht = /* @__PURE__ */ S({
  __name: "MiniappDebugbar",
  setup(p) {
    const { initConsole: a } = A();
    a();
    const _ = [
      {
        id: "console",
        name: "Console",
        component: F
      },
      {
        id: "network",
        name: "Network",
        component: pt
      }
    ], s = I(!1), e = j(_[0]), k = (b) => {
      e.value !== b && (e.value = b);
    }, u = (b) => e.value === b, f = () => s.value = !0, $ = () => s.value = !1;
    return (b, x) => (i(), r("div", ut, [
      E(n("button", {
        class: "miniapp-debugbar-btn",
        onClick: f
      }, " Debugbar ", 512), [
        [H, !s.value]
      ]),
      s.value ? (i(), r("div", dt, [
        n("ul", kt, [
          (i(), r(h, null, O(_, (m) => n("li", {
            key: m.id,
            class: D(["miniapp-debugbar__option", {
              "miniapp-debugbar__option--active": u(m)
            }]),
            onClick: (N) => k(m)
          }, l(m.name), 11, bt)), 64))
        ]),
        n("div", mt, [
          (i(), P(U(e.value.component)))
        ]),
        n("button", {
          class: "miniapp-debugbar__btn-close",
          onClick: $
        })
      ])) : y("", !0)
    ]));
  }
});
export {
  ht as ChocoMiniappDebugbar,
  A as useConsole,
  V as useNetwork
};
